var _defs, _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes flash-ani{0%{opacity:.4}to{opacity:1}}.bg_circle_svg__cls-1{fill:#4377ff}.bg_circle_svg__cls-2{fill:#8faeff}.bg_circle_svg__cls-3{fill:#aec4ff}.bg_circle_svg__ellipseGroup01 ellipse,.bg_circle_svg__ellipseGroup02 ellipse{animation-name:flash-ani;animation-iteration-count:infinite;animation-direction:alternate}.bg_circle_svg__ellipseGroup01 ellipse:nth-of-type(1),.bg_circle_svg__ellipseGroup02 ellipse:nth-of-type(3){animation-duration:.4s}.bg_circle_svg__ellipseGroup01 ellipse:nth-of-type(2),.bg_circle_svg__ellipseGroup02 ellipse:nth-of-type(1){animation-duration:.7s}.bg_circle_svg__ellipseGroup01 ellipse:nth-of-type(3),.bg_circle_svg__ellipseGroup02 ellipse:nth-of-type(2){animation-duration:1.1s}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup01"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 22.4,
    cy: 24.2,
    rx: 0.6,
    ry: 0.3,
    transform: "rotate(-6.05 22.359 24.184)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 23.7,
    cy: 24.9,
    rx: 0.6,
    ry: 0.3,
    transform: "rotate(-6.05 23.726 24.942)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 25.1,
    cy: 25.7,
    rx: 0.6,
    ry: 0.3,
    transform: "rotate(-6.05 25.12 25.712)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 13.6,
    cy: 87,
    rx: 0.6,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 15.1,
    cy: 86,
    rx: 0.6,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 16.7,
    cy: 85.2,
    rx: 0.6,
    ry: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup01"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 182.35,
    cy: 27.22,
    rx: 0.63,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 183.91,
    cy: 26.25,
    rx: 0.63,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 185.47,
    cy: 25.43,
    rx: 0.63,
    ry: 0.41
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 167.04,
    cy: 137.63,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 167.02 137.673)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 168.4,
    cy: 138.39,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 168.403 138.41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 169.8,
    cy: 139.16,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 169.788 139.148)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 254.41,
    cy: 47.31,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 254.434 47.318)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 255.78,
    cy: 48.06,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 255.819 48.055)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 257.17,
    cy: 48.83,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 257.203 48.792)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-1",
    cx: 276.18,
    cy: 122.17,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 276.19 122.19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-2",
    cx: 277.55,
    cy: 122.93,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 277.575 122.927)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bg_circle_svg__cls-3",
    cx: 278.94,
    cy: 123.7,
    rx: 0.56,
    ry: 0.33,
    transform: "rotate(-6.05 278.959 123.664)"
  }))));
}

export default SvgBgCircle;